import React from 'react';
import { List, Datagrid, TextField, DateField, EmailField, ShowButton } from 'react-admin';
import UserFilters from './UserFilters';
import UserActions from './UserActions';
import BooleanIntegerField from '../../fields/BooleanIntegerField';
import ActivateDeactivateButton from './ActivateDeactivateButton';

const UserList = props => (
  <List {...props} filters={<UserFilters />} bulkActionButtons={false} actions={<UserActions />}>
    <Datagrid>
      <TextField source="id" />
      <EmailField source="email" />
      <TextField source="company_name" />
      <TextField source="company_user_id" />
      <TextField source="primary_role.name" label="Role" />
      <BooleanIntegerField source="is_active" />
      <BooleanIntegerField source="commercial_agree" />
      {/* <FunctionField label="VCorsi" render={record => (record.coach && record.coach.remote_user_id ? 'Yes' : 'No')} /> */}
      <TextField source="full_name" sortable={false} />
      <TextField source="phone_number" />
      <TextField source="billing_address_id" />
      <DateField source="created_at" showTime />
      <DateField source="last_login_at" showTime />
      <DateField source="subscription_start_at" showTime />
      <DateField source="subscription_end_at" showTime />
      <DateField source="subscription_payed_at" showTime />
      <TextField source="subscription_diff_month" />
      <ShowButton />
      <ActivateDeactivateButton />
    </Datagrid>
  </List>
);

export default UserList;



// WEBPACK FOOTER //
// ./src/resources/users/UserList.jsx